import React from 'react'

import { DisableHtmlTagScroll } from './DisableHtmlTagScroll'

export const MobileDropdown = ({
  children: dropdownContent,
}: {
  children: React.ReactNode
}) => {
  const headerBottomPosition =
    document?.querySelector('.mc-page__header')?.getBoundingClientRect()
      .bottom || 62

  return (
    <div
      style={{
        top: headerBottomPosition,
        left: 0,
        right: 0,
        bottom: 0,
        position: 'fixed',
        backgroundColor: 'var(--mc-theme-background)',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <DisableHtmlTagScroll />
      {dropdownContent}
    </div>
  )
}
